/* eslint-disable react/prop-types */
import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import '~styles/modules/quiz.scss';

const AgreedList = function ({
  candidates, images, qid, choice,
}) {
  const qindex = parseInt(qid.replace('q', ''), 10) - 1;
  const cid = qid.replace('q', 'c');
  // list of headshots
  const list = candidates.map((candidate) => {
    const imgSrc = getImage(images.find((image) => image.base === candidate.img));
    const cn = `candidate ${candidate[qid]}`;
    return (
      <li key={candidate.shortName} className={cn}>
        <GatsbyImage image={imgSrc} alt={candidate.shortName} layout="fluid" placeholder="none" title={candidate.name} />
      </li>
    );
  });
  // detailed list
  const ditailedlist = candidates.map((candidate) => {
    const cn = `bentoncond-n4 context ${candidate[qid]}`;
    if (candidate[cid]) {
      return (
        <li key={candidate.shortName} className={cn}>
          <strong className="bentoncond-n6">
            {candidate.shortName}
            :
            {' '}
          </strong>
          <span>{candidate[cid]}</span>
        </li>
      );
    }
  });
  // Add a note on question 5
  // const q05exception = (qid === 'q05') ? <div className="results-content note bentoncond-n4">NOTE: Kim Janey refused to answer this question.</div> : null;
  const listid = `list${qid}`;
  const visibleClass = choice[qindex] ? `results show ${choice[qindex]}` : 'results';
  return (
    <div className={visibleClass}>
      <div className="results-content bentoncond-n4">
        <span>
          Candidates who
          <br />
          agree with you:
        </span>
        <ul className="agreedlist" id={listid}>
          {list}
        </ul>
      </div>
      {/* {q05exception} */}
      <div className="results-detail bentoncond-n4">
        <ul className="detailedlist">
          {ditailedlist}
        </ul>
      </div>
    </div>
  );
};

export default AgreedList;
